import React from 'react';
import styled from 'astroturf/react';
import _Anchor from "Link-Anchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/Link.tsx?styleId=Anchor";
import _LinkAnchor from "Link-LinkAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/Link.tsx?styleId=LinkAnchor";


const Anchor = /*#__PURE__*/styled("a", null, {
  displayName: "Anchor",
  styles: _Anchor
});

const LinkAnchor = /*#__PURE__*/styled(Anchor, null, {
  displayName: "LinkAnchor",
  styles: _LinkAnchor
});

export const Link: React.FC<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & { linked?: boolean }
> = ({ href, children, linked = true, ...props }) => {
  if (linked) {
    return (
      <LinkAnchor href={href} {...props}>
        {children}
      </LinkAnchor>
    );
  } else {
    return <Anchor {...props}>{children}</Anchor>;
  }
};
